module.exports = __webpack_public_path__ + "img/bg.97a7579a.png";